<template>
  <press-center
      :in-category="1684"
      current-url="Video"
      in-name="video"
  />
</template>

<script>
import PressCenter from "@/views/PressCenter";
export default {
  name: "PressVideo",
  components: {PressCenter},
  mounted () {
  }
}
</script>

<style scoped>

</style>
